import { useEffect, useState } from 'react';

const getViewport = () => {
  const width = typeof window === 'undefined' ? 1280 : window.innerWidth;
  return {
    width,
    isMobile: width <= 768,
    isTablet: width <= 1024,
    isNarrow: width <= 560,
  };
};

export default function useResponsive() {
  const [viewport, setViewport] = useState(getViewport);

  useEffect(() => {
    const handleResize = () => setViewport(getViewport());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return viewport;
}
